import ReactTooltip from "react-tooltip";
import { customStyle } from "../../algorithms/styleDirection";
import Lang from "../../userPreferences/staticWords";
import { Link } from "react-router-dom";
import "./communityStyle.css";
import { paths } from "../../paths/paths";
const CoverBar = ({ details }) => {
  if (details) {
    let img;
    if (details.coverPhoto)
      img = `url('${paths.CommunityCoverPhoto}${details.id}/${details.coverPhoto}') center center / cover no-repeat`;
    else
      img =
        "url('/assets/images/Group 8260.png') center center / cover no-repeat";

    return (
      <div
        className="w-100 cover-stickyClass"
        style={{
          height: 180,
          background: img,
          opacity: 1,
          zIndex: 10,
        }}
      >
        <div
          className="p-0"
          style={{
            height: "inherit",
            backgroundColor: "rgba(26, 115, 232, 0.3)",
          }}
        >
          <ul className="nav px-lg-5 px-2 justify-content-center align-items-center h-100">
            {/* <li
              className="mx-3 position-relative"
              data-tip
              data-for={customStyle("l1")}
            >
              <ReactTooltip
                id={customStyle("l1")}
                type="info"
                effect="solid"
                place={"bottom"}
                backgroundColor="#0a58ca"
                arrowColor="#0a58ca"
              >
                <span>{Lang.projectsNavTab}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/projects"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 50,
                    width: 50,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      background:
                        "url('/assets/images/icons/projection-screen.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
              </Link>
            </li> */}

            <li
              className="mx-3 position-relative"
              data-tip
              data-for={customStyle("l2")}
            >
              <ReactTooltip
                id={customStyle("l2")}
                type="info"
                effect="solid"
                place={"bottom"}
                backgroundColor="#0a58ca"
                arrowColor="#0a58ca"
              >
                <span>{Lang.tasksNavTab}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/tasks/index"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 50,
                    width: 50,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 24,
                      height: 22,
                      background:
                        "url('/assets/images/icons/fi-br-layers.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
              </Link>
            </li>

            {/* <li
            
          
            data-tip
            data-for={customStyle("l3")}
            accessKey="3"
          >
            <ReactTooltip
              id={customStyle("l3")}
              type="info"
              effect="solid"
              place={"bottom"}
              backgroundColor="#0a58ca"
              arrowColor="#0a58ca"
            >
              <span>{Lang.calenderNavTab}</span>
            </ReactTooltip>

            <a
              style={{ width: 65 }}
              href="#"
              className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
            >
              <div
                style={{
                  backgroundColor: "white",
                  height: 50,
                  width: 50,
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
                className="d-flex justify-content-center text-center align-items-center my-1"
              >
                <div
                  style={{
                    width: 24,
                    height: 24,
                    background:
                      "url('/assets/images/icons/fi-br-calendar.png') 0% 0% no-repeat padding-box",
                    opacity: 1,
                  }}
                ></div>
              </div>
              
            </a>
          </li>
*/}
            {/* <li
              className="mx-3 position-relative"
              data-tip
              data-for={customStyle("l4")}
            >
              <ReactTooltip
                id={customStyle("l4")}
                type="info"
                effect="solid"
                place={"bottom"}
                backgroundColor="#0a58ca"
                arrowColor="#0a58ca"
              >
                <span>{Lang.discussionCirclesNavTab}</span>
              </ReactTooltip>

              <Link
                style={{ width: 65 }}
                to={"/discussion"}
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 50,
                    width: 50,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      background:
                        "url('/assets/images/icons/fi-br-comments.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
              </Link>
            </li> */}

            <li
              className="mx-3 position-relative"
              data-tip
              data-for={customStyle("l5")}
            >
              <ReactTooltip
                id={customStyle("l5")}
                type="info"
                effect="solid"
                place={"bottom"}
                backgroundColor="#0a58ca"
                arrowColor="#0a58ca"
              >
                <span>{Lang.filesNavTab}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/files"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 50,
                    width: 50,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      background:
                        "url('/assets/images/icons/fi-br-folder.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
              </Link>
            </li>

            {/* <li
              className="mx-3 position-relative"
              data-tip
              data-for={customStyle("l6")}
            >
              <ReactTooltip
                id={customStyle("l6")}
                type="info"
                effect="solid"
                place={"bottom"}
                backgroundColor="#0a58ca"
                arrowColor="#0a58ca"
              >
                <span>{Lang.infoPanelNavTab}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to={"/dashboard"}
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 50,
                    width: 50,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      background:
                        "url('/assets/images/icons/fi-br-signal-alt-1.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                    }}
                  ></div>
                </div>
              </Link>
            </li> */}

            <li
              className="mx-3 position-relative"
              data-tip
              data-for={customStyle("l7")}
            >
              <ReactTooltip
                id={customStyle("l7")}
                type="info"
                effect="solid"
                place={"bottom"}
                backgroundColor="#0a58ca"
                arrowColor="#0a58ca"
              >
                <span>{Lang.workTeam}</span>
              </ReactTooltip>
              <Link
                style={{ width: 65 }}
                to="/workTeam"
                className="d-flex align-items-center justify-content-center flex-column text-decoration-none px-3 pt-3"
              >
                <div
                  style={{
                    backgroundColor: "white",
                    height: 50,
                    width: 50,
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                  className="d-flex justify-content-center text-center align-items-center my-1"
                >
                  <div
                    style={{
                      width: 30,
                      height: 30,
                      background:
                        "url('/assets/images/icon3.png') 0% 0% no-repeat padding-box",
                      opacity: 1,
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                    }}
                  ></div>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
  return <div></div>;
};

export default CoverBar;
